import { Component, OnInit } from '@angular/core';

import { ModalsService } from '../../services/modals.service';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss']
})
export class LoadingScreenComponent implements OnInit {
  private isOpened: boolean;

  constructor(
    private modals: ModalsService,
  ) {
    this.modals.toggleLoadingScreenEvent.subscribe((state: boolean) => {
      this.isOpened = state;
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modals/loading-screen/loading-screen.component.ts